import { Suspense, FC } from "react";
import dynamic from "next/dynamic";
import DetailController from "../../../controller/precon/precondetail.controller";
import { GetServerSideProps } from "next/types";
import Head from "next/head";
const Details = dynamic(() => import("../../../Layout/PreconDetail/Details"), {
  suspense: true,
});
const Header = dynamic(() => import("../../../Layout/PreconDetail/Header"), {
  suspense: true,
});

interface DetailProps {
  data: any;
}

const Index: FC<DetailProps> = ({ data }) => {
  return (
    <>
      <Head>
        <title>{`${data.title} - BungalowFinder `}</title>
        <meta name="title" content={`${data.title} - BungalowFinder`} />
        <meta name="description" content={data.desc} />

        <meta
          property="og:url"
          content={"https://bungalowfinder.ca/newconstruction/" + data.slug}
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${data.title} - BungalowFinder`} />
        <meta property="og:description" content={data.desc} />

        <meta
          property="og:image"
          itemProp="image"
          content={"https://api.bungalowfinder.ca" + data.logo.url}
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content={`${data.title} - BungalowFinder`}
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content={` ${data.title} - BungalowFinder`}
        />
        <meta name="twitter:description" content={data.desc} />
        <meta
          name="twitter:image"
          content={"https://api.bungalowfinder.ca" + data.logo.url}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: (data.jsonLD && data.jsonLD) || "",
          }}
        ></script>
      </Head>
      <div>
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <Header headImage={data.images} title={data.title} />
        </Suspense>
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <Details data={data} />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
export const getServerSideProps: GetServerSideProps = async (context) => {
  return await DetailController(context);
};
